export default __webpack_public_path__ + "static/media/donate.ccefdefb.jpg";